import { SearchParams } from '@api/constants';
import ImprivataLogo from '@assets/Imprivata_Logo.svg?react';
import { ImprUserDropdown } from '@imprivata-cloud/components';
import { useIdleTimeout } from '@portal/hooks/useIdleTimeout';
import { useLocalLogout, useLogout } from '@portal/hooks/useLogout';
import { type PropsWithChildren, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './SelfServiceLayout.less';
import useAgentWindow from '@hooks/useAgentWindow';
import { determineWindowCloseTimeoutMins } from '@selfservice/utils/helpers';

export interface SelfServiceLayoutProps {
  username: string;
  email: string;
  logoUrl: string;
}

const SelfServiceLayout = ({
  children,
  username,
  logoUrl,
  email,
}: PropsWithChildren<SelfServiceLayoutProps>) => {
  useAgentWindow(['beforeunload']);

  const [searchParams] = useSearchParams();
  const timeout = determineWindowCloseTimeoutMins(searchParams.get(SearchParams.WINDOW_CLOSE_SEC));

  const handleLocalLogout = useLocalLogout();
  const handleLogout = useLogout();
  const { startIdleTimer, stopIdleTimer } = useIdleTimeout(timeout, handleLocalLogout);

  useEffect(() => {
    startIdleTimer();
    return () => {
      stopIdleTimer();
    };
  }, [startIdleTimer, stopIdleTimer]);

  useEffect(() => {
    // this means that there was no redirect here from idp so we failed logout the previous user
    if (document.referrer.includes('app-access')) {
      void handleLocalLogout();
    }
  }, [handleLocalLogout]);

  return (
    <div className="self-service-layout">
      <header>
        <div className="header-content">
          <div className="logo-container">
            <ImprivataLogo />
          </div>
          <ImprUserDropdown
            username={username}
            email={email}
            onLogout={handleLogout}
            aria-label={'user-menu'}
          />
        </div>
      </header>

      <main>{children}</main>

      <footer>
        <img src={logoUrl} alt="logo" />
        <div className="footer-right">My Imprivata Identity</div>
      </footer>
    </div>
  );
};

export default SelfServiceLayout;
